import React, { useContext, useState, useEffect } from 'react'
import './Sidebar.css'
import { useNavigate, useLocation } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import GroupIcon from '@mui/icons-material/Group'
import DashboardIcon from '@mui/icons-material/Dashboard'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import SettingsIcon from '@mui/icons-material/Settings'
import LogoutIcon from '@mui/icons-material/Logout'
import WarehouseIcon from '@mui/icons-material/Warehouse'
import MenuIcon from '@mui/icons-material/Menu'
import AssessmentIcon from '@mui/icons-material/Assessment'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { AuthContext } from '../../context/AuthContext'
import { useTranslation } from 'react-i18next'
import menuIcon from '../../assets/menu.png'
import { WidthFull } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
/* ===== Logout ===== */
const LogoutButton = () => {
  const { logout } = useContext(AuthContext)
  const { t } = useTranslation()

  return (
    // <Tooltip title={'ログアウト'} placement='right'>
    <div className='menu-item logout' onClick={logout}>
      <LogoutIcon className='menu-icon' />
      <span className='menu-label'>ログアウト</span>
    </div>
    // </Tooltip>
  )
}

const Sidebar = ({ collapsed, onToggleCollapse }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()
  const { role } = useContext(AuthContext)
  const [activeItem, setActiveItem] = useState('')

  useEffect(() => {
    const path = location.pathname
    if (path.includes('/home/schedule')) setActiveItem('schedule')
    else if (path.includes('/home/user-approvals'))
      setActiveItem('user-approvals')
    else if (path.includes('/home/users')) setActiveItem('users')
    else if (path.includes('/home/staff')) setActiveItem('staff')
    else if (path.includes('/home/order')) setActiveItem('order')
    else if (path.includes('/home/inventory')) setActiveItem('inventory')
    else if (path.includes('/home/analytics')) setActiveItem('analytics')
    else if (path.includes('/home/supplier')) setActiveItem('supplier')
    else if (path.includes('/home/settings')) setActiveItem('settings')
    else if (path.includes('/home')) setActiveItem('home')
    else setActiveItem('')
  }, [location.pathname])

  const handleNavigation = (path, key) => {
    setActiveItem(key)
    navigate(path)
  }

  const menuItems = [
    {
      icon: <CalendarMonthIcon className='menu-icon' />,
      label: '荷割画面',
      path: '/home/schedule',
      key: 'schedule'
    },

    {
      icon: <AssessmentIcon className='menu-icon' />,
      label: 'ダッシュボード',
      path: '/home/analytics',
      key: 'analytics'
    },
    ...(role === 'admin'
      ? [
          {
            icon: <ManageAccountsIcon className='menu-icon' />,
            label: 'ユーザー承認',
            path: '/home/user-approvals',
            key: 'user-approvals'
          }
        ]
      : [])
  ]

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      {/* ===== HEADER ===== */}
      <div className='sidebar-header'>
        <div className='logo-container'>
          <span className='logo-text'>Meisei</span>
        </div>
        {/* <Tooltip title={collapsed ? '展開' : '折りたたむ'} placement='right'>
          <button className='toggle-btn' onClick={onToggleCollapse}>
            <img
              src={menuIcon}
              alt='Menu'
              className='menu-icon-image'
              style={{ width: 20, height: 20 }}
            />
          </button>
        </Tooltip> */}
      </div>

      {/* ===== MENU ===== */}
      <div className='menu'>
        {menuItems.map((item) => (
          // <Tooltip  title={item.label} placement='right'>
          <div
            key={item.key}
            className={`menu-item ${activeItem === item.key ? 'active' : ''}`}
            onClick={() => handleNavigation(item.path, item.key)}
          >
            {item.icon}
            <span className='menu-label'>{item.label}</span>
          </div>
          // </Tooltip>
        ))}
        <LogoutButton />
      </div>

      {/* ===== FOOTER ===== */}
      <div className='sidebar-footer'>Copyright © 2026 Aimesoft</div>
    </div>
  )
}

export default Sidebar
